import { toast } from "react-toastify";
import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import type { Event } from "../../../services/webServices/event/types";
import { patchEvent } from "../../../services/webServices/event/patch";

type Props = {
  event: Event;
  onActionSuccessed: () => void;
};

export default function EventsAction({ event, onActionSuccessed }: Props) {

  const updateEventStatus = async (status: number): Promise<boolean> => {
    if (event.publish_status === status) {
      toast.info("وضعیت همین الان هم همین است");
      return false;
    }

    try {
      const success = await patchEvent({
        slugOrId: event.id,
        body: { publish_status: status }
      });

      if (!success) return false;

      toast.success("تغییر وضعیت با موفقیت انجام شد");
      onActionSuccessed();
      return true;
    } catch {
      return false;
    }
  };

  const actions: DropdownItem[] = [
    {
      key: "draft",
      tone: "info",
      label: "پیش نویس",
      action: () => updateEventStatus(1),
    },
    {
      key: "awaiting_confirmation",
      tone: "secondary",
      label: "در انتظار تایید",
      action: () => updateEventStatus(2),
    },
    {
      key: "published",
      tone: "success",
      label: "منتشر شده",
      action: () => updateEventStatus(3),
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={
        event.publish_status === 1
          ? "draft"
          : event.publish_status === 2
          ? "awaiting_confirmation"
          : "published"
      }
    />
  );
}